export default "__VITE_ASSET__Cn9qT7pG__"